<template>
  <div>
    <v-toolbar dark color="primary">

      <v-toolbar-title class="white--text">wots nu?</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon @click="$router.push('post/' + groupId)">
        +
      </v-btn>
    </v-toolbar>

    <div v-if="allPosts">
      <div v-for="(aPost, index) in allPosts" :key="index">
        <Post :post-data="aPost"/>
        <br/>
      </div>
    </div>

    <!--
    <v-tabs centered color="grey" dark slider-color="red">

      <v-tab key="1" ripple> This week</v-tab>

      <v-tab key="2" ripple> Profile</v-tab>

      <v-tab-item key="1">
        <div v-if="allPosts">
          <div v-for="(aPost, index) in allPosts" :key="index">
            <Post :post-data="aPost"/>
            <br/>
          </div>
        </div>
      </v-tab-item>

      <v-tab-item key="2"><Profile/></v-tab-item>
    </v-tabs> -->
  </div>
</template>

<script>
import Post from './Post'
import Profile from './Profile'
import {mapState, mapActions} from 'vuex'

const fb = require('../firebase')

export default {
  name: 'Home',
  components: {Post, Profile},
  data () {
    return {
      // allPosts: [],
      groupId: 'TXOSAetRGy7ZpqV4gn51'
    }
  },
  mounted () {
    let user = fb.auth.currentUser
    if (!user) {
      this.$router.push({path: '/login'})
    } else {
      this.fetchAll()
      this.$store.commit('setActiveUser', fb.auth.currentUser.uid)
    }
  },
  computed: {
    ...mapState(['posts']),
    allPosts: function () {
      return Object.values(this.posts)
    }
  },
  methods: {
    ...mapActions(['fetchAll']),
    next () {
      const active = parseInt(this.active)
      this.active = (active < 2 ? active + 1 : 0)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Home.vue